import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import type { addFavouriteListItemProps } from "../../../models/addFavouriteListItemProps";
import { addRoadDirectionToList, addTypeToRoadDirection, addValueToType, changeFavouritesList, deleteFavouriteList, deleteValueFromList } from "../../../stateManagement/reducers/FavouritesSlice";
import { store } from "../../../stateManagement/store";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";
const trashCanSrc = require('../../../assets/images/fontAwesomeIcons/trash-can-solid.svg').default

// Компонент - список в окне добавления в закладки
export function AddFavouriteListItem({ name, objectInfo }: addFavouriteListItemProps) {
    // получение типа объекта из url
    const { objectTypeName } = useParams()
    const dispatch = useDispatch()
    // получение информации о выбранном объекте
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    let lists: any
    // получение списка закладок
    lists = getItemWebStorage("favourites") ? getItemWebStorage("favourites") : store.getState().favourites.lists
    // определение дороги, к которой принадлежит объект
    const roadDirection = lists?.find((item: any) => item.name === name).roadDirections?.find((roadDirection: any) => roadDirection.name === (objectInfo.RoadName + " - " + objectInfo.PathName))
    const checked = roadDirection?.types.find((type: any) => type.name === objectTypeName)?.items.find((item: any) => item?.id === objectInfo.InfoObjectID) ? true : false
    // функция для добавления объекта в список закладок
    function onListChoose(event: any) {
        let addParams: any = {}
        if (objectTypeName === 'RoadSigns') {
            addParams.signImage = `${currentApiUrl}/objects/roadSignImage?Token='${token}'&Id=${objectInfo.InfoObjectID}&Width=300&Height=300`
        }
        // обновление списка закладок в хранилище
        dispatch(changeFavouritesList(lists))
        // добавление в список, если объекта не было в списке
        if (!checked) {
            // проверка, на какой уровень добавлять объект в зависимости от наличия в списке уже добавленных объектов такой же Дороги / Типа Объекта / Объекта
            if (!roadDirection) {
                dispatch(addRoadDirectionToList({
                    listName: event.value,
                    roadDirection: {
                        name: objectInfo.RoadName + " - " + objectInfo.PathName,
                        listName: event.value,
                        types: [{
                            name: objectTypeName,
                            roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                            listName: event.value,
                            items: [{
                                id: objectInfo.InfoObjectID,
                                name: objectTypeName,
                                position: objectInfo.PathPosition,
                                ending: objectInfo.PathEnding,
                                placement: objectInfo.PlacementString,
                                listName: event.value,
                                roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                                addParams: addParams
                            }]
                        }]
                    }
                }))
            } else if (!roadDirection.types.find((type: any) => type.name === objectTypeName)) {
                dispatch(addTypeToRoadDirection({
                    roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                    listName: event.value,
                    type: {
                        name: objectTypeName,
                        roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                        listName: event.value,
                        items: [{
                            id: objectInfo.InfoObjectID,
                            name: objectTypeName,
                            position: objectInfo.PathPosition,
                            ending: objectInfo.PathEnding,
                            placement: objectInfo.PlacementString,
                            listName: event.value,
                            roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                            addParams: addParams
                        }]
                    }
                }))
            } else if (!roadDirection.types.find((type: any) => type.name === objectTypeName).items.find((item: any) => item.id === objectInfo.InfoObjectID)) {
                dispatch(addValueToType({
                    roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                    listName: event.value,
                    type: objectTypeName,
                    item: {
                        id: objectInfo.InfoObjectID,
                        name: objectTypeName,
                        position: objectInfo.PathPosition,
                        ending: objectInfo.PathEnding,
                        placement: objectInfo.PlacementString,
                        listName: event.value,
                        roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName,
                        addParams: addParams
                    }
                }))
            }
        }
        // удаление из списка, если объект уже был в выбранном списке
        else {
            const favouriteDeleteMark = store.getState().favourites.favouriteDeleted
            dispatch(deleteValueFromList({ roadDirectionName: objectInfo.RoadName + " - " + objectInfo.PathName, listName: event.value, type: objectTypeName, id: objectInfo.InfoObjectID, favouriteDeleted: !favouriteDeleteMark }))
        }
        // сохранение списка закладок в локальном состоянии
        const favourites = store.getState().favourites.lists
        setItemWebStorage('favourites', favourites)
    }

    // функция удаления списка закладок
    function deleteList(name: any) {
        const favouriteDeleteMark = store.getState().favourites.favouriteDeleted
        dispatch(deleteFavouriteList({ name: name, favouriteDeleted: !favouriteDeleteMark }))
        const favourites = store.getState().favourites.lists
        setItemWebStorage('favourites', favourites)
    }

    return (
        <div className="flex add-favourite-list-item mt-2 justify-content-between align-items-center">
            <div>
                <Checkbox inputId={name} name={name} value={name} onChange={(e) => onListChoose(e)} checked={checked} />
                <label htmlFor={name} className="ms-2">{name}</label>
            </div>
            <div>
                {/* Кнопка удаления списка закладок */}
                <Button onClick={() => deleteList(name)}
                    className="delete-but text-center" severity="danger"><img src={trashCanSrc} height={17} width={17} />
                </Button>
            </div>
        </div>
    );
}

